import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CorporateRoutingModule } from "./corporate-routing.module";
import { CorporateTruckDetailsComponent } from "./corporate-truck-details/corporate-truck-details.component";
import { CorporateDashboardComponent } from "./corporate-dashboard/corporate-dashboard.component";
import { CorporateTripsComponent } from "./corporate-trips/corporate-trips.component";
import { CorporateTripsDetailsComponent } from "./corporate-trips-details/corporate-trips-details.component";
import { CorporateWorkOrdersComponent } from "./corporate-work-orders/corporate-work-orders.component";
import { CorporateLedgerComponent } from "./corporate-ledger/corporate-ledger.component";
import { CorporateHeaderComponent } from "./corporate-header/corporate-header.component";
import { MaterialModule } from "../material/material-module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GoogleMapsModule } from "@angular/google-maps";
import { CorporateWorkorderDetailsComponent } from "./corporate-workorder-details/corporate-workorder-details.component";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { CorporateProfileComponent } from "./corporate-profile/corporate-profile.component";
import { MapTrackerComponent } from "./map-tracker/map-tracker.component";
import { CorporateDeleteAccountComponent } from "./corporate-delete-account/corporate-delete-account.component";
import { UppercaseInputDirective } from "./uppercase-corporate";
import { TwoDigitDecimaNumberDirective } from "../corporate/two-digit-decima-number.directive";
import { UpperCaseInputDirective } from "./uppercase-input.directive";
import { AlphanumericOnlyDirective } from "./alpha-numeric.directives";
import { CustomDateAdapter } from "./custome-directives";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { CorporateCancelTripComponent } from './corporate-cancel-trip/corporate-cancel-trip.component';
import { CorporateLrUpdateComponent } from './corporate-lr-update/corporate-lr-update.component';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: "dd-MM-yyyy",
  },
  display: {
    dateInput: "dd-MM-yyyy",
    monthYearLabel: "MMM yyyy",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
@NgModule({
  declarations: [
    CorporateTruckDetailsComponent,
    CorporateDashboardComponent,
    CorporateTripsComponent,
    CorporateTripsDetailsComponent,
    CorporateWorkOrdersComponent,
    CorporateLedgerComponent,
    CorporateHeaderComponent,
    CorporateWorkorderDetailsComponent,
    CorporateProfileComponent,
    MapTrackerComponent,
    CorporateDeleteAccountComponent,
    UppercaseInputDirective,
    UpperCaseInputDirective,
    TwoDigitDecimaNumberDirective,
    AlphanumericOnlyDirective,
    CorporateCancelTripComponent,
    CorporateLrUpdateComponent,
  ],
  imports: [
    CommonModule,
    CorporateRoutingModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    GoogleMapsModule,
    MatButtonToggleModule,
  ],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: DateAdapter, useClass: CustomDateAdapter },
  ],
})
export class CorporateModule {}
